import React,{Component} from 'react';
import './DynamicAsset.scss';

class DynamicAsset extends Component{
    constructor(){
        super();
    }
    render(){
        let img= this.props.image;
        return(
        <div className="dynamic-content-asset">
             <div className="dynamic-content-asset-thumbnail"  >
                 <img src={require('./../../../assets/images/' + this.props.image).default}></img>
             </div>
              <div className="dynamic-content-asset-content">
                  <div className="dynamic-content-asset-label">{this.props.title}</div>
                  <div className="dynamic-content-asset-text">{this.props.description}</div>
                  <a className="btn dynamic-content-asset-btn"
                   href={this.props.ctaURL} 
                   target="_blank"
                   rel="noreferrer"
                   tabindex={this.props.tabby}
                   >{this.props.ctaText}</a>
             </div>
        </div>        
        );
    }
}

export default DynamicAsset;